import { Controller } from "@hotwired/stimulus"

// Modern task form controller to replace jQuery AJAX submissions
export default class extends Controller {
  static targets = ["taskName"]
  
  connect() {
  }
  
  // Handle label clicks
  labelClicked(event) {
    const label = event.target;
    const radioInput = label.querySelector('input[type="radio"]');
    
    if (radioInput) {
      // Manually check the radio button
      radioInput.checked = true;
      
      // Trigger change event
      const changeEvent = new Event('change', { bubbles: true });
      radioInput.dispatchEvent(changeEvent);
    }
  }

  // Handle task name blur event - auto-submit form
  async submitOnBlur(event) {
    const element = event.target
    const form = element.closest("form")
    
    if (!form) {
      console.error("No form found for task element")
      return
    }
    
    // Don't submit if this is the edit_task modal
    if (element.closest('#edit_task')) {
      return
    }
    
    // Small delay to allow other changes to register
    setTimeout(() => {
      this.submitTaskForm(form)
    }, 10)
  }

  async submitTaskForm(form) {
    try {
      const formData = new FormData(form)
      
      const response = await fetch(form.action, {
        method: form.method || 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/vnd.turbo-stream.html, application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        }
      })
      
      if (response.ok) {
        // Check if response is Turbo Stream
        const contentType = response.headers.get('Content-Type')
        if (contentType && contentType.includes('turbo-stream')) {
          const turboStreamContent = await response.text()
          if (window.Turbo) {
            // Process Turbo Stream response
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = turboStreamContent
            const turboStreamElements = tempDiv.querySelectorAll('turbo-stream')
            
            turboStreamElements.forEach(element => {
              window.Turbo.renderStreamMessage(element.outerHTML)
            })
          }
        } else {
          // Task form submitted successfully
        }
      } else {
        console.error('Task save failed:', response.status, response.statusText)
      }
    } catch (error) {
      console.error('Task save error:', error)
    }
  }
  
  // Handle direct form submission
  async submitForm(event) {
    // Small delay to ensure the change is registered
    setTimeout(() => {
      // Get the form
      const form = this.element
      
      // Submit the form via Turbo
      form.requestSubmit()
    }, 50)
  }
}